import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { ActionButton } from '@fluentui/react';
import { useColumnSelect } from '../Provider/useColumnSelect';
/**
 * A button to reset the column selection to the default.
 */
export const ColumnSelectReset = (_a) => {
    var { children = 'Reset to default' } = _a, rest = __rest(_a, ["children"]);
    const { setSelectedKeyList, defaultColumnKeyList } = useColumnSelect();
    return (_jsx(ActionButton, Object.assign({ iconProps: { iconName: 'ChromeClose' } }, rest, { onClick: () => {
            setSelectedKeyList(defaultColumnKeyList);
        } }, { children: children })));
};
